// extracted by mini-css-extract-plugin
module.exports = {"pg-email__filter__actions":"styles_pg-email__filter__actions__3B3sX","pg-email__table":"styles_pg-email__table__dtRHA"};